import { store } from '@betacrew/jars-flux'
import { FORM_LISTING_LOADING_STATES } from '../constants';

export const componentKey = "FORMS_DETAILS_DRAWER";

const { actions } = store.reducerManager.add({
    key: componentKey,
    addedReducers: {
        setLoadingState: (state, action) => {
            state.loadingState = action.payload;
        },
        setCategorisedFormFields: (state, action) => {
            state.categorisedFormFields = action.payload
        },
        setFormDetails: (state, action) => {
            state.formDetails = action.payload
        },
        setTinVerificationAmount: (state, action) => {
            state.tinVerificationAmount = action.payload
        },
    },
    initialReducerState: {
        loadingState: { state: FORM_LISTING_LOADING_STATES.GET_FORM_DETAILS_LOADING, message: "" },
        categorisedFormFields: {},
        formDetails: {},
        tinVerificationAmount: 0.00
    }
});

export const { setLoadingState, setCategorisedFormFields, setFormDetails, setTinVerificationAmount } = actions;